const sel = "h-10 rounded-md border bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-accent";

export function ListingControls({ value, onChange, counts }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const opts = [["all", `All (${counts.all})`], ["in", `In stock (${counts.in})`], ["out", `Out of stock (${counts.out})`]];
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="listing-controls">
      <div className="hidden sm:inline-flex rounded-lg border bg-white p-1" role="group" aria-label="Stock filter">
        {opts.map(([v, l]) => (
          <button key={v} onClick={() => set("stock", v)} data-testid={`filter-stock-${v}`} aria-pressed={value.stock === v}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${value.stock === v ? "bg-steel text-white" : "text-muted-foreground hover:text-steel"}`}>{l}</button>))}
      </div>
      <select value={value.stock} onChange={(e) => set("stock", e.target.value)} className={`sm:hidden flex-1 min-w-0 ${sel}`} aria-label="Stock filter" data-testid="filter-stock-select">
        {opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <label className="flex items-center gap-2 text-sm text-muted-foreground sm:ml-auto flex-1 sm:flex-none min-w-0"><span className="hidden sm:inline">Sort by</span>
        <select value={value.sort} onChange={(e) => set("sort", e.target.value)} className={`w-full sm:w-auto ${sel}`} aria-label="Sort by" data-testid="sort-select">
          <option value="relevance">Relevance</option>
          <option value="price_asc">Price: low to high</option>
          <option value="price_desc">Price: high to low</option>
        </select>
      </label>
    </div>
  );
}
